/**
 * Frontend error tracker — POSTs errors to the trade middleware
 * which forwards them to Sentry with resource tags.
 *
 * Usage:
 *   window.trackTradeError(error, { source: 'MyComponent.method', quoteId })
 *   window.tradeFetch(url, options, { quoteId })
 */
(function () {
  'use strict';

  window.tradeApiBase = window.tradeApiBase || '/apps/trade';

  window.trackTradeError = function (error, context) {
    // Skip errors that have already been reported (e.g. rethrown from tradeFetch)
    if (error && error.reported) return;
    if (error && typeof error === 'object') error.reported = true;

    const label = (context && context.source) ? '[' + context.source + ']' : '[Trade]';
    console.error(label, error);

    const entry = {
      message: (error && error.message) || String(error),
      stack: (error && error.stack) || undefined,
      context: {
        pageUrl: location.protocol + '//' + location.host + location.pathname,
        userAgent: navigator.userAgent,
      },
    };

    if (context && context.quoteId) {
      entry.context.quoteId = String(context.quoteId);
    }
    if (context && context.requestUrl) {
      entry.context.requestUrl = String(context.requestUrl).slice(0, 2048);
    }
    if (context && context.requestBody) {
      entry.context.requestBody = String(context.requestBody).slice(0, 2000);
    }
    if (context && context.responseBody) {
      entry.context.responseBody = String(context.responseBody).slice(0, 2000);
    }
    if (context && context.source) {
      entry.source = String(context.source).slice(0, 256);
    }

    fetch(window.tradeApiBase + '/errors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ errors: [entry] }),
    }).catch(function () {});
  };

  window.tradeFetch = async function (url, options, context) {
    let response;
    try {
      response = await fetch(url, options);
    } catch (error) {
      // Network errors (offline, DNS, CORS)
      trackTradeError(error, Object.assign({}, context, { requestUrl: url }));
      throw error;
    }

    if (!response.ok) {
      const body = await response.text();

      // Try to extract a readable message from JSON error responses
      let message = response.status + ' ' + response.statusText;
      let errorId;
      try {
        const parsed = JSON.parse(body);
        if (parsed.error) message = parsed.error;
        if (parsed.errorId) errorId = parsed.errorId;
      } catch (e) {
        if (body) message = body.slice(0, 200);
      }

      const error = new Error(message);
      error.status = response.status;
      error.errorId = errorId;

      // Don't report 4xx (expected: not found, permission, validation)
      // or 5xx the middleware has already captured
      const alreadyHandled = response.status < 500 || Boolean(errorId);
      if (alreadyHandled) {
        error.reported = true;
      } else {
        trackTradeError(error, Object.assign({}, context, {
          requestUrl: url,
          requestBody: options && options.body ? String(options.body).slice(0, 2000) : undefined,
          responseBody: body ? body.slice(0, 2000) : undefined,
        }));
      }
      throw error;
    }

    return response;
  };
})();
